/* istanbul ignore file: we do not need to care about the entry point file as errors are detected through E2E */ /**
 * The entrypoint for the knowledgebase search shortcode.
 */ import { jsx as _jsx } from "react/jsx-runtime";
import "@devowl-wp/utils/lib/antd.scss";
import $ from "jquery";
import { createRoot } from "react-dom/client";
import { ready } from "@devowl-wp/react-utils";
import { Provider } from "./components/provider.js";
import { KnowledgeBaseSearch } from "./shortcode/knowledgeBaseSearch/input.js";
ready().then(()=>{
    // Query DOM for all widget wrapper divs
    const elements = document.querySelectorAll("div.devowl-knowledge-base-search");
    // Iterate over the DOM nodes and render a React component into each node
    elements.forEach((item)=>createRoot(item).render(/*#__PURE__*/ _jsx(Provider, {
            children: /*#__PURE__*/ _jsx(KnowledgeBaseSearch, {
                ...$(item).data()
            })
        })));
});
